<template>
  <v-container fill-height fluid>
    <v-container>
      <v-row no-gutters>
        <v-col cols="8">
          <drillLibSingleView :parentEditedItem="this.drillLib.edges[0].node" />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import drillLibSingleView from "./drill_lib_single_view.vue";

export default {
  components: {
    drillLibSingleView
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      return {
        inner: this.drillName
      };
    },
    meta: function() {
      return [
        { property: "og:description", content: this.drillDesc },
        { property: "og:image:alt", content: this.drillName },
        {
          property: "og:title",
          content: this.drillName + " #" + this.sportType + " #" + this.tag
        },
        { property: "og:type", content: "video.movie" },
        {
          property: "og:image",
          content:
            "https://img.youtube.com/vi/" + this.videoId + "/maxresdefault.jpg"
        },
        {
          property: "og:url",
          content: "https://portal.sportecos.com" + this.$route.fullPath
        },
        { property: "og:video", content: this.videoUrl },
        { property: "og:video:type", content: "video/mp4" },
        { property: "og:video:width", content: "640" },
        { property: "og:video:height", content: "385" }
      ];
    }
  },
  //props: ["drillId", "formTitle", "nameRules", "requiredRule", "status"],
  data() {
    return {
      //  title: '',
      //  title: 'Drill Lib dialog',
      visible: true,
      // loading: false,
      // error: null,
      editedItem: []
    };
  },
  //name: DrillLibDialog,
  created() {
    // this.handleGetDrillList();
  },
  // watch: {
  //   // call again the method if the route changes
  //   '$route': 'handleGetDrillList'
  // },
  computed: {
    ...mapGetters(["loading", "error", "drillLib"]),
    drillVideo() {
      let str = this.drillLib.edges[0].node.videoUrl;
      return !(Object.entries(this.drillLib.edges).length === 0)
        ? "https://www.youtube.com/v/" +
            str.substring(str.search("/embed/") + 7)
        : "Edit Activity";
      // return !(Object.entries(this.drillLib.edges).length === 0) ? "https://www.youtube.com/v/" + str.substring(str.search('/embed/')+7) + ";rel=0;&autoplay=1&mute=1&loop=1&playlist=" + str.substring(str.search('/embed/')+7) : "Edit Activity";
    },
    drillTitle() {
      return (
        this.drillLib.edges[0].node.drillName +
        " " +
        this.drillLib.edges[0].node.sportType +
        " Drill"
      );
    },
    drillUrl() {
      let str = this.drillLib.edges[0].node.videoUrl;
      return !(Object.entries(this.drillLib.edges).length === 0)
        ? "https://www.youtube.com/watch?v=" +
            str.substring(str.search("/embed/") + 7)
        : "Edit Activity";
    },
    dialog: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  methods: {
    handleGetDrillList() {
      //reach out of Vuex store, fire action that gets Drill
      this.$store.dispatch("allDrillLib", {
        drillName: this.$route.params.drillName
      });
    }
  },
  mounted() {
    //  this.editedItem = this.drillLib.edges[0].node;
  }
};
</script>
